import type React from 'react';

function BringIconMiniColor(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 53.94 53.94"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Bring Icon Mini Color</title>

      <g id="Layer_1-2" data-name="Layer 1">
        <rect width="53.94" height="53.94" fill="none" />

        <g id="g3395">
          <path
            id="Fill-3"
            d="M15.63,40.46c-7,.04-12.86-5.31-13.45-12.28H0c.82,14.93,13.58,26.37,28.51,25.55,8.62-.47,16.5-5.03,21.21-12.27,2.57-3.97,4.03-8.56,4.22-13.29H29.08c-.59,6.98-6.45,12.33-13.45,12.29Z"
            fill="#c1c1c1"
          />

          <path
            id="Fill-4"
            d="M2.18,26.05c.7-7.43,7.29-12.88,14.72-12.18,6.46,.61,11.57,5.72,12.18,12.18h24.86C53.24,11.16,40.59-.35,25.7,.35,11.79,1.01,.66,12.14,0,26.05H2.18"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
}

export default BringIconMiniColor;
